import React, { useEffect, useState, useRef } from "react";
import FullCalendar, { isPropsEqual } from "@fullcalendar/react";
import daygridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from '@fullcalendar/timegrid';
import esLocale from '@fullcalendar/core/locales/es';
import interactionPlugin from '@fullcalendar/interaction';
import FormNuevaCita from "./FormNuevaCita";
import axios from '../../axios/axiosconf';
import { leadingZero, getHoraCita, getElementosHora, getAmpm } from "../../../resources/Helper";
import { Modal, Button } from "react-bootstrap";
import { useHistory } from "react-router";
import AgendaTooltip from "../custom/AgendaTooltip";
import Unauthorized from "../general/Unauthorized";

function Agenda(props) {

    const [showFormNuevaCita, setShowFormNuevaCita] = useState(false);
    const [date, setDate] = useState('');
    const [time, setTime] = useState('');
    const [modalState, setModalState] = useState('hidden');
    const [citas, setCitas] = useState([]);
    const [extendedProps, setExtendedProps] = useState({});

    const [idCita, setIdCita] = useState('');
    const [idPaciente, setIdPaciente] = useState('');
    const [primerNombre, setPrimerNombre] = useState('');
    const [segundoNombre, setSegundoNombre] = useState('');
    const [primerApellido, setPrimerApellido] = useState('');
    const [segundoApellido, setSegundoApellido] = useState('');
    const [email, setEmail] = useState('');
    const [celular, setCelular] = useState('');
    const [tipoDocumento, setTipoDocumento] = useState('');
    const [numeroDocumento, setNumeroDocumento] = useState('');

    const [duracionCita, setDuracionCita] = useState('');
    const [estadoCita, setEstadoCita] = useState('');
    const [idEstadoCita, setIdEstadoCita] = useState('');
    const [unidadAtencion, setUnidadAtencion] = useState('');
    const [motivoConsulta, setMotivoConsulta] = useState('');
    const [verCita, setVerCita] = useState(false);
    const [puedeAtender, setPuedeAtender] = useState('');

    const [idUsuarioAgenda, setIdUsuarioAgenda] = useState('');
    const [idUnidadAgenda, setIdUnidadAgenda] = useState('');

    const [primeraVez, setPrimeraVez] = useState();

    const [nuevoEstadoCita, setNuevoEstadoCita] = useState(props.nuevoEstadoCita);
    const [show, setShow] = useState(false);
    const handleClose = () => {
        localStorage.removeItem('userAgenda');
        setShow(false);
    }

    const [msgReagendarCita, setMsgReagendarCita] = useState();
    const [showCitaDrop, setShowCitaDrop] = useState(false);

    const [idCitaDrop, setIdCitaDrop] = useState();
    const [fechaCitaDrop, setFechaCitaDrop] = useState();
    const [horaCitaDrop, setHoraCitaDrop] = useState();

    // Estados para horarios de agenda
    const [slotMinTime, setSlotMinTime] = useState('00:00:00');
    const [slotMaxTime, setSlotMaxTime] = useState('24:00:00');
    const [hasPermission, setHasPermission] = useState(null); // null = aún no validado
    const [calendarReady, setCalendarReady] = useState(false);
    const [estadoCitaDrop, setEstadoCitaDrop] = useState();
    const [duracionCitaDrop, setDuracionCitaDrop] = useState();
    const [fechaInicioOriginalCitaDrop, setFechaInicioOriginalCitaDrop] = useState();
    const [fechaInicioOriginalCitaDropStr, setFechaInicioOriginalCitaDropStr] = useState();
    const [fechaFinOriginalCitaDrop, setFechaFinOriginalCitaDrop] = useState();
    const [fechaFinOriginalCitaDropStr, setFechaFinOriginalCitaDropStr] = useState();
    const [idUsuarioReagenda, setIdUsuarioReagenda] = useState();

    const [horaAtencionCita, setHoraAtencionCita] = useState();
    const [minutoCita, setMinutoCita] = useState();
    const [ampmCita, setAmpmCita] = useState();

    const [tooltipTop, setTooltipTop] = useState();
    const [tooltipLeft, setTooltipLeft] = useState();
    const [tooltipDisplay, setTooltipDisplay] = useState();
    const [contenidoTooltip, setContenidoTooltip] = useState('');

    const [estadoPorDefecto, setEstadoPorDefecto] = useState();
    const [permisos, setPermisos] = useState([]);
    const [stepCita, setStepCita] = useState();
    const [slotDuration, setSlotDuration] = useState('00:30:00');

    const calendarRef = useRef();
    const [bloquearEstadoCita, setBloquearEstadoCita] = useState(false);

    let userdata = [];
    let history = useHistory();

    const handleNuevaCita = () => {
        setShow(false);

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                uid: userdata.user_id,
                id: idPaciente
            }
        }

        axios.get('paciente', config)
            .then(response => {
                //console.log(response.data);
                setPrimerNombre(response.data[0].primer_nombre);
                setSegundoNombre(response.data[0].segundo_nombre);
                setPrimerApellido(response.data[0].primer_apellido);
                setSegundoApellido(response.data[0].segundo_apellido);
                setEmail(response.data[0].email);
                setCelular(response.data[0].celular);
                setTipoDocumento(response.data[0].tipo_documento);
                setNumeroDocumento(response.data[0].numero_documento);
                setIdPaciente(idPaciente);
                //setModalState('visible');
                history.push('/agenda-profesional');
            })
            .catch(error => {
                console.log(error);
            })
    }


    const calendarClick = (info) => {

        if (permisos.includes('crearCitas')) {
            const fechaISO = new Date(info.dateStr);
            const fechaCita = fechaISO.getFullYear() + '-' + leadingZero(fechaISO.getMonth() + 1) + '-' + leadingZero(fechaISO.getDate());
            const horaCita = leadingZero(fechaISO.getHours()) + ':' + leadingZero(fechaISO.getMinutes()) + ':00';

            setDate(fechaCita);
            setTime(horaCita);
            setExtendedProps(null);

            setHoraAtencionCita(getHoraCita(fechaISO.getHours()));
            setMinutoCita(leadingZero(fechaISO.getMinutes()));
            setAmpmCita(getAmpm(fechaISO.getHours()));

            setIdCita('');
            setPrimerNombre('');
            setSegundoNombre('');
            setPrimerApellido('');
            setSegundoApellido('');
            setEmail('');
            setCelular('');
            setTipoDocumento('');
            setNumeroDocumento('');

            setDuracionCita('');
            setEstadoCita('');
            setIdEstadoCita('');
            setUnidadAtencion('');
            setMotivoConsulta('');
            setVerCita(false);
            setPrimeraVez(true);

            setBloquearEstadoCita(true);
            //setIdEstadoCita(1);
            setEstadoPorDefecto('asignada');

            setModalState('visible');
        }
    }


    function clicCita(e) {
        setDate(e.event.extendedProps.fecha_cita);
        setTime(e.event.extendedProps.hora_cita);

        setPrimerNombre(e.event.extendedProps.primer_nombre);
        setSegundoNombre(e.event.extendedProps.segundo_nombre);
        setPrimerApellido(e.event.extendedProps.primer_apellido);
        setSegundoApellido(e.event.extendedProps.segundo_apellido);
        setEmail(e.event.extendedProps.email);
        setCelular(e.event.extendedProps.celular);
        setTipoDocumento(e.event.extendedProps.tipo_documento);
        setNumeroDocumento(e.event.extendedProps.numero_documento);
        setIdPaciente(e.event.extendedProps.id_paciente);

        setDuracionCita(e.event.extendedProps.duracion_cita);
        setEstadoCita(e.event.extendedProps.estado_cita);
        setIdEstadoCita(e.event.extendedProps.id_estado_cita);
        setUnidadAtencion(e.event.extendedProps.id_unidad_atencion);
        setMotivoConsulta(e.event.extendedProps.motivo_consulta);
        setVerCita(true);
        setPrimeraVez(false);

        setIdCita(e.event.extendedProps.id_cita);

        setHoraAtencionCita(getElementosHora(e.event.extendedProps.hora_cita)[0]);
        setMinutoCita(getElementosHora(e.event.extendedProps.hora_cita)[1]);
        setAmpmCita(getElementosHora(e.event.extendedProps.hora_cita)[2]);

        setBloquearEstadoCita(false);

        if (e.event.extendedProps.estado == '1') {
            setPuedeAtender(true);
        }
        else {
            setPuedeAtender(false);
        }

        if (e.event.extendedProps.estado_cita != null) {
            setModalState('visible');
        }
    }


    function handleCitaDrop(info) {
        const fechaISO = new Date(info.event.start);
        const fechaCita = fechaISO.getFullYear() + '-' + leadingZero(fechaISO.getMonth() + 1) + '-' + leadingZero(fechaISO.getDate());
        const horaCita = leadingZero(fechaISO.getHours()) + ':' + leadingZero(fechaISO.getMinutes()) + ':00';

        setMsgReagendarCita('¿Confirmas el reagendamiento de la cita para el ' + fechaCita + ' a las ' + horaCita + '?');
        setShowCitaDrop(true);

        setIdCitaDrop(info.oldEvent.extendedProps.id_cita);
        setFechaCitaDrop(fechaCita);
        setHoraCitaDrop(horaCita);
        setEstadoCitaDrop(info.oldEvent.extendedProps.id_estado_cita);
        setDuracionCitaDrop(info.oldEvent.extendedProps.duracion_cita);
        setTooltipDisplay('none');

        setFechaInicioOriginalCitaDrop(info.oldEvent.start);
        setFechaFinOriginalCitaDrop(info.oldEvent.end);
        setFechaInicioOriginalCitaDropStr(info.oldEvent.startStr);
        setFechaFinOriginalCitaDropStr(info.oldEvent.endStr);
        setIdUsuarioReagenda(info.oldEvent.extendedProps.id_users);
    }

    function handleReagendarCita() {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            uid: userdata.user_id,
            id: idCitaDrop,
            fecha_cita: fechaCitaDrop,
            hora_cita: horaCitaDrop,
            estado_cita: estadoCitaDrop,
            duracion_cita: duracionCitaDrop,
            hora_atencion_cita: '1',
            minuto_cita: '0',
            ampm: 'am',
            id_users: idUsuarioAgenda
        }

        axios.put('cita', config)
            .then(response => {
                if (response.status === 200) {
                    //setToastMsg('La cita ha sido reagendada.');
                    //setTimeout(() => { setShowToast(true) },800);
                }
            })
            .catch(error => {
                console.log(error);
            })

        setShowCitaDrop(false);
    }


    const handleCloseCitaDrop = () => {
        setShowCitaDrop(false);
        getCitas();
    }


    function handleMouseEnter(info) {

        let np = info.event.extendedProps.segundo_nombre ? info.event.extendedProps.primer_nombre + " " + info.event.extendedProps.segundo_nombre : info.event.extendedProps.primer_nombre;
        
        // Manejar segundo_apellido que puede ser null, "null" o vacío
        let segundoApellido = info.event.extendedProps.segundo_apellido;
        let ap = info.event.extendedProps.primer_apellido;
        if (segundoApellido && segundoApellido !== 'null' && segundoApellido.trim() !== '') {
            ap += " " + segundoApellido;
        }

        let elemRect = info.el.getBoundingClientRect();

        let offsetLeft = elemRect.left;
        let elementHeight = elemRect.height;
        let offsetTop = elemRect.bottom + 10; // 10px spacing below event

        // Adjust if tooltip goes off screen right
        if (offsetLeft + 300 > window.innerWidth) {
            offsetLeft = window.innerWidth - 320;
        }

        // Adjust if tooltip goes off screen bottom (simple check, or just let it be)
        if (offsetTop + 150 > window.innerHeight) {
            offsetTop = elemRect.top - 150; // Show above if no space below
        }

        let contenidott = `<p><strong>Paciente: </strong>${np + ' ' + ap}</p>
                                <p><strong>Documento: </strong>${info.event.extendedProps.numero_documento ? info.event.extendedProps.numero_documento : ''}</p>
                                <p><strong>Estado De La Cita: </strong>${info.event.extendedProps.estado_cita ? info.event.extendedProps.estado_cita : ''}</p>
                                <p><strong>Unidad De Atención: </strong>${info.event.extendedProps.nombre_unidad ? info.event.extendedProps.nombre_unidad : ''}</p>
                                <p><strong>Motivo De Consulta: </strong>${info.event.extendedProps.motivo_consulta ? info.event.extendedProps.motivo_consulta : ''}</p>
                                <p><strong>Celular: </strong>${info.event.extendedProps.celular ? info.event.extendedProps.celular : ''}</p>
                                <p><strong>e-mail: </strong>${info.event.extendedProps.email ? info.event.extendedProps.email : ''}</p>`;

        if (info.event.extendedProps.bloqueo) {
            contenidott = `<p><strong>Bloqueo de agenda: </strong>${info.event.extendedProps.descripcion_bloqueo}</p>`;
        }

        setContenidoTooltip(contenidott);

        setTooltipTop(offsetTop + 'px');
        setTooltipLeft(offsetLeft + 'px');
        setTooltipDisplay('block');
    }

    function handleMouseLeave(info) {

        setTooltipDisplay('');
    }


    useEffect(() => {
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));

            // 🔒 VALIDACIÓN DE PERMISOS HÍBRIDA - Verificar acceso a ver agenda
            let tienePermiso = false;
            
            if (userdata.permissions && Array.isArray(userdata.permissions)) {
                tienePermiso = userdata.permissions.some(permission => permission.slug === 'verAgenda');
            } else if (userdata.up && userdata.up.includes('verAgenda')) {
                tienePermiso = true;
            }

            if (!tienePermiso) {
                setHasPermission(false);
                return; // Detener ejecución si no tiene permisos
            }

            setHasPermission(true);

            setStepCita(userdata.step);
            setSlotDuration('00:' + userdata.step + ':00');
            setPermisos(userdata.up || []);
        }

        // ✅ Cargar horarios de agenda
        axios.get('/horario-agenda')
            .then(response => {
                if (response.status === 200) {
                    // Si es el rango por defecto (00:00:00 - 23:59:00), usar 24 horas completas
                    if (response.data.hora_inicio === '00:00:00' && response.data.hora_fin === '23:59:00') {
                        setSlotMinTime('00:00:00');
                        setSlotMaxTime('24:00:00');
                    } else {
                        // FullCalendar usa slotMaxTime como límite exclusivo
                        // Agregar 30 minutos para incluir la última hora completa
                        const horaFin = response.data.hora_fin.split(':');
                        const horas = parseInt(horaFin[0]);
                        const minutos = parseInt(horaFin[1]);
                        
                        // Calcular nueva hora fin con 30 minutos adicionales
                        let nuevosMinutos = minutos + 30;
                        let nuevasHoras = horas;
                        
                        if (nuevosMinutos >= 60) {
                            nuevosMinutos -= 60;
                            nuevasHoras += 1;
                        }
                        
                        const horaFinAjustada = `${String(nuevasHoras).padStart(2, '0')}:${String(nuevosMinutos).padStart(2, '0')}:00`;
                        
                        setSlotMinTime(response.data.hora_inicio);
                        setSlotMaxTime(horaFinAjustada);
                    }
                }
            })
            .catch(error => {
                console.log('Usando horarios por defecto (24h)');
                // Mantener valores por defecto si hay error
            });

        // 🔒 Validar que el calendario esté montado antes de acceder a la API
        if (calendarRef.current) {
            try {
                let calendarApi = calendarRef.current.getApi();
                let currentTime = new Date();

                setCalendarReady(true); // Marcar calendario como listo

                setTimeout(() => {
                    if (calendarApi && calendarApi.scrollToTime) {
                        calendarApi.scrollToTime(currentTime.getHours() + ':00');
                    }
                }, 300);
            } catch (error) {
                console.warn('Error Al Configurar El Scroll Del Calendario:', error);
            }
        }
    }, []);


    useEffect(() => {

        if (extendedProps) {
            getCitas();
        }

    }, [extendedProps]);

    useEffect(() => {
        setIdUsuarioAgenda(props.profesionalAsignado);
    }, [props.profesionalAsignado]);

    useEffect(() => {
        setIdUnidadAgenda(props.unidad);
    }, [props.unidad]);

    useEffect(() => {
        getCitas2();
    }, [idUsuarioAgenda]);

    useEffect(() => {
        getCitasPorUnidad();
    }, [idUnidadAgenda]);



    useEffect(() => {
        if (props.agendarCitaPaciente != null) {
            //setModalState('visible');
            setIdPaciente(props.agendarCitaPaciente);
            setShow(true);
        }
    }, [props.agendarCitaPaciente]);


    useEffect(() => {
        setNuevoEstadoCita(props.estadoNuevaCita);
    }, [props.estadoNuevaCita]);


    useEffect(() => {
        // 🔒 Validar que el calendario esté montado y listo antes de acceder a la API
        if (calendarRef.current && props.irAFecha) {
            try {
                let calendarApi = calendarRef.current.getApi();
                calendarApi.gotoDate(props.irAFecha);
            } catch (error) {
                console.warn('Error Al Navegar A La Fecha En El Calendario:', error);
            }
        }
    }, [props.irAFecha, calendarReady]);





    function getCitas() {

        // ✅ Solo cargar citas si hay una agenda seleccionada
        if (!idUsuarioAgenda || idUsuarioAgenda === '24' || idUsuarioAgenda === 24) {
            console.log('No hay agenda seleccionada, saltando carga de citas');
            setCitas([]);
            return;
        }

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                uid: userdata.user_id
            }
        }

        axios.get('/citas-profesional', config)
            .then(response => {
                setCitas(response.data);
            })
            .catch(error => {
                console.log(error.response?.message);
                setCitas([]);
            })
    }


    function getCitas2() {

        props.citaAgendada();

        // ✅ Solo cargar citas si hay una agenda seleccionada
        if (!idUsuarioAgenda || idUsuarioAgenda === '24' || idUsuarioAgenda === 24) {
            console.log('No hay agenda seleccionada, saltando carga de citas');
            setCitas([]);
            return;
        }

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                uid: idUsuarioAgenda
            }
        }

        console.log('Cargando citas para agenda:', idUsuarioAgenda);

        axios.get('/citas-profesional', config)
            .then(response => {
                setCitas(response.data);
                console.log('Citas cargadas:', response.data.length);
            })
            .catch(error => {
                console.log('Error cargando citas:', error.response?.status, error.response?.data);
                setCitas([]);
            })
    }


    function getCitasPorUnidad() {

        // ✅ Solo cargar citas si hay una unidad seleccionada
        if (!idUnidadAgenda) {
            console.log('No hay unidad seleccionada, saltando carga de citas por unidad');
            return;
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                id: idUnidadAgenda
            }
        }

        console.log('Cargando citas para unidad:', idUnidadAgenda);

        axios.get('/citas-unidad', config)
            .then(response => {
                setCitas(response.data);
                console.log('Citas por unidad cargadas:', response.data.length);
            })
            .catch(error => {
                console.log('Error cargando citas por unidad:', error.response?.status);
            })
    }



    // 🔒 PROTECCIÓN DE RUTA - Si no tiene permisos, mostrar página de acceso denegado
    if (hasPermission === false) {
        return <Unauthorized />;
    }

    // ⏳ Mientras valida permisos, no mostrar nada (evita flash del modal)
    if (hasPermission === null) {
        return null;
    }

    return (
        <div>
            <FullCalendar
                plugins={[daygridPlugin, timeGridPlugin, interactionPlugin]}
                initialView="timeGridDay"
                locale={esLocale}
                allDaySlot={false}
                headerToolbar={{
                    left: 'prev,next today',
                    center: 'title',
                    right: 'dayGridMonth,timeGridWeek,timeGridDay'
                }}

                dateClick={calendarClick}
                events={citas}
                eventClick={clicCita}
                editable={true}
                eventDrop={handleCitaDrop}
                eventMouseEnter={handleMouseEnter}
                eventMouseLeave={handleMouseLeave}
                eventDragStart={() => setTooltipDisplay('none')}
                eventOverlap={false}
                ref={calendarRef}
                slotDuration={slotDuration}
                slotLabelInterval={slotDuration}
                height={'70vh'}
                slotMinTime={slotMinTime}
                slotMaxTime={slotMaxTime}

                slotLabelFormat={{
                    hour: 'numeric',
                    minute: '2-digit',
                    omitZeroMinute: false,
                    meridiem: 'short',
                    hour12: true
                }}
            >

            </FullCalendar>

            <FormNuevaCita
                modalState={modalState}
                closeModal={modalState => setModalState('hidden')}
                profesionalAsignado={props.profesionalAsignado}
                nombreProfesionalAsignado={props.nombreProfesionalAsignado}
                usuarioAsigna={props.usuarioAsigna}
                nombreUsuarioAsigna={props.nombreUsuarioAsigna}
                fecha={date}
                hora={time}
                reloadCitas={getCitas}
                reloadCitasAgenda={getCitas2}
                extendedProps={extendedProps}
                primerNombre={primerNombre}
                segundoNombre={segundoNombre}
                primerApellido={primerApellido}
                segundoApellido={segundoApellido}
                email={email}
                celular={celular}
                tipoDocumento={tipoDocumento}
                numeroDocumento={numeroDocumento}
                duracionCita={duracionCita}
                estadoCita={idEstadoCita}
                unidadAtencion={unidadAtencion}
                motivoConsulta={motivoConsulta}
                verCita={verCita}
                puedeAtender={puedeAtender}
                idPaciente={idPaciente}
                primeraVez={primeraVez}
                idCita={idCita}

                horaAtencionCita={horaAtencionCita}
                minutoCita={minutoCita}
                ampmCita={ampmCita}

                agendarCitaPaciente={props.agendarCitaPaciente}
                bloquearProfesional={props.bloquearProfesional}
                bloquearEstadoCita={bloquearEstadoCita}
                stepCita={stepCita}
                estadoPorDefecto={estadoPorDefecto}

            />

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Cita {nuevoEstadoCita}</Modal.Title>
                </Modal.Header>
                <Modal.Body>¿Deseas Asignar Otra Cita Para Este Paciente?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>No</Button>
                    <Button variant="primary" onClick={handleNuevaCita}>Si</Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showCitaDrop} onHide={handleCloseCitaDrop}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmar Reagendamiento</Modal.Title>
                </Modal.Header>
                <Modal.Body>{msgReagendarCita}</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseCitaDrop}>No</Button>
                    <Button variant="primary" onClick={handleReagendarCita}>Si</Button>
                </Modal.Footer>
            </Modal>

            <AgendaTooltip top={tooltipTop} left={tooltipLeft} display={tooltipDisplay} contenido={contenidoTooltip} />
        </div>
    );
}
export default Agenda;